<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{
                $t("Registro de Situações de Violação de Direitos")
            }}
        </h1>
        <form @submit.prevent="submit" ref="addItem">
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-select
                    v-model="violacaodedireito.pessoas"
                    :multiple="true"
                    label="Vítima(s)"
                    :itens="pessoas"
                    :required="true"
                />
                <form-select
                    v-model="violacaodedireito.violencias"
                    label="Violação de Direitos"
                    :multiple="true"
                    :itens="tipos"
                    :required="true"
                    :disabled="loadingTipos"
                    :loading="loadingTipos"
                />
                <form-toggle
                    v-model="violacaodedireito.acompanhamento_creas"
                    grid="12"
                    label="Acompanhamento"
                />
                <div
                    class="col-md-12"
                    v-if="violacaodedireito.acompanhamento_creas == 1"
                >
                    <div class="row">
                        <form-select
                            v-model="violacaodedireito.creas_id"
                            label="Unidade"
                            grid="6"
                            :itens="unidades"
                        />
                        <form-calendar
                            v-model="acomp_data_inicial"
                            grid="3"
                            label="Data Inicial"
                        />
                        <form-calendar
                            v-model="acomp_data_final"
                            grid="3"
                            label="Data Final"
                        />
                    </div>
                </div>
                <form-textarea-editor
                    v-model="violacaodedireito.descricao"
                    grid="12"
                    label="Descrição da situação de Violação de Direitos e suas supostas motivações"
                    :required="true"
                />
                <form-select
                    v-model="violacaodedireito.tecnicos"
                    label="Técnicos participantes"
                    :multiple="true"
                    :itens="listtecnicos"
                    :disabled="loadingTecnicos"
                    :loading="loadingTecnicos"
                />
                <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="violacaodedireito.privado"
                    label="Sigilo?"
                />
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["familia", "morph"],
    name: "Add",
    data() {
        return {
            violacaodedireito: {privado:false},
            tecnicos: [],
            unidades: [],
            orientadores: [],
            tipos: [],
            files: {},
            loadUser: true,
            progressCompleted: 0,
            disabled: true,
            loadingTipos: false,
            loadingTecnicos: false,
            disabledacomp: true,
            acomp_data_inicial: null,
            acomp_data_final: null,
        };
    },
    computed: {
        pessoas() {
            this.getTecnicos();
            this.getUnidades();
            this.getTipos();
            let pessoas = this.familia.familiares;
            pessoas = pessoas.filter((elem) => {
                return elem.estado_cadastral_cadunico <= 3;
            });
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value: elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
            }));
            return map;
        },
        listtecnicos() {
            const pessoas = this.tecnicos;
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value: " <b>" + elem.value + "</b> - " + (elem.profissao ?? 'Não informado') + " - " + elem.nome_unidade,
            }));
            return map;
        },
    },
    mounted(){
        // this.privateFromOsasco()
    },
    methods: {
        // privateFromOsasco() {
        //   const role_name = this.$store.state.user.role_details.name;
        
        //     if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'suasfacil.host'|| window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
        //         this.violacaodedireito.privado =  1;
        //     } else {
        //         this.violacaodedireito.privado =  2;
        //     }
        // },
        submitFile(files) {
            this.files = files;
        },
        getUnidades() {
            axios
                .get(`api/dashboard/violacaodedireitos/unidades`)
                .then((response) => {
                    this.unidades = response.data;
                });
        },
        getTipos() {
            this.loadingTipos = true;
            axios
                .get(`api/dashboard/violacaodedireitos/tipos`)
                .then((response) => {
                    this.tipos = response.data;
                    this.loadingTipos = false;
                });
        },
        submit() {
            this.violacaodedireito.morph = this.morph;
            this.violacaodedireito.acomp_data_inicial = this.acomp_data_inicial;
            this.violacaodedireito.acomp_data_final = this.acomp_data_final;
            // if (this.acomp_data_inicial) {
            //     this.violacaodedireito.acomp_data_inicial = moment(
            //         this.acomp_data_inicial,
            //         "YYYY-MM-DD"
            //     ).format("YYYY-MM-DD");
            // }
            // if (this.acomp_data_final) {
            //     this.violacaodedireito.acomp_data_final = moment(
            //         this.acomp_data_final,
            //         "YYYY-MM-DD"
            //     ).format("YYYY-MM-DD");
            // }
            this.violacaodedireito.familia_id = this.$route.params.id;
            this.$route.query.familia_id = this.$route.params.id;
            let formData = new FormData();
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }
            for (var key in this.violacaodedireito) {
                if (
                    key == "morph" &&
                    this.violacaodedireito.morph != undefined
                ) {
                    formData.append(key, this.violacaodedireito[key]);
                    formData.append("morph_id", this.morph.id);
                    formData.append("morph_type", this.morph.type);
                } else {
                    formData.append(key, this.violacaodedireito[key]);
                }
            }
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/violacaodedireitos`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    if (this.morph != undefined) {
                        this.$emit("reload");
                    } else {
                        this.$router.push(
                            `/dashboard/violacaodedireitos/edit/${response.data.data.id}?familia_id=${this.$route.params.id}`
                        );
                    }
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
        getTecnicos() {
            this.loadingTecnicos = true;
            axios
                .get(`api/dashboard/atendimento/tecnicos/get`)
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadingTecnicos = false;
                });
        },
    },
};
</script>
